import { createStyles, makeStyles } from '@hawkins/styles';
var indeterminateAnimation = {
    '0%': {
        transform: 'translateX(0) scaleX(0)',
    },
    '40%': {
        transform: 'translateX(0) scaleX(0.4)',
    },
    '100%': {
        transform: 'translateX(100%) scaleX(0.5)',
    },
};
var generateThemeVariables = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    if (hawkins.theme === 'light') {
        return {
            circularProgressBackground: hawkins.ui.backgroundColor6,
            linearTrackBackground: hawkins.ui.backgroundColor4,
            linearProgressBackground: hawkins.ui.backgroundColor6,
        };
    }
    return {
        circularProgressBackground: hawkinsVariables.colors.white,
        linearTrackBackground: hawkinsVariables.colors.grayDarkT40,
        linearProgressBackground: hawkinsVariables.colors.white,
    };
};
export var loaderStyles = function (theme) {
    var _a;
    var themeVariables = generateThemeVariables(theme);
    return createStyles({
        /** Class name to apply to the root of the component */
        root: {
            color: themeVariables.linearProgressBackground,
        },
        /** Class name to apply when the variant is "circular" */
        circular: {
            transform: 'rotate(-90deg)',
            color: themeVariables.circularProgressBackground,
        },
        /** Class name to apply to the circular progress track */
        circularProgressTrack: {
            strokeLinecap: 'round',
        },
        /** Class name to apply to the wrapper of the "linear" progress */
        linear: {
            width: '100%',
            backgroundColor: themeVariables.linearTrackBackground,
            borderRadius: 2,
            height: 4,
            appearance: 'none',
            verticalAlign: '4px',
        },
        /** Class name to apply when the variant is "linear" */
        linearDeterminate: {
            '&::-webkit-progress-bar': {
                borderRadius: 2,
                backgroundColor: themeVariables.linearTrackBackground,
            },
            '&::-webkit-progress-value': {
                borderRadius: 2,
                backgroundColor: 'currentColor',
            },
        },
        /** Class name to apply to the indeterminate linear progress root */
        linearIndeterminate: {
            width: '100%',
            borderRadius: 2,
        },
        /** Class name to apply to the indeterminate linear progress track */
        linearIndeterminateProgressTrack: {
            height: '4px',
            backgroundColor: themeVariables.linearTrackBackground,
            width: '100%',
            overflow: 'hidden',
            borderRadius: 2,
        },
        /** Class name to apply to the indeterminate linear progress bar */
        linearIndeterminateProgressBar: {
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            animation: '$progress 1s infinite linear',
            transformOrigin: '0% 50%',
            borderRadius: 2,
        },
        /** @private */
        circularIndeterminate: {
            position: 'relative',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                borderTop: "2px solid currentColor",
                borderRight: '2px solid transparent',
                animation: 'spinner 1.2s linear infinite',
            },
        },
        /** @private */
        '@global': (_a = {},
            _a["@keyframes spinner"] = {
                to: {
                    transform: 'rotate(360deg)',
                },
            },
            _a),
        /** @private */
        '@keyframes progress': indeterminateAnimation,
    });
};
export var useLoaderStyles = makeStyles(loaderStyles, { name: 'Hawkins-Loader' });
